import React from 'react';

interface AddPatientButtonProps {
    onClick?: () => void;
    isDisabled?: boolean;
}

const AddPatientButton: React.FC<AddPatientButtonProps> = ({ onClick, isDisabled }) => (
    <button
        onClick={onClick}
        className={`flex items-center gap-2 bg-black text-white font-semibold px-6 py-2 rounded-xl shadow hover:bg-gray-900 transition-colors ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        disabled={isDisabled}
    >
        <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
        Add patient
    </button>
);

export default AddPatientButton;
